export default {
  navigationBarTitleText: '优惠券'
};
